/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsMethodNotAllowedError
 */
export interface NotificationsMethodNotAllowedError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsMethodNotAllowedError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsMethodNotAllowedError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsMethodNotAllowedError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsMethodNotAllowedError interface.
 */
export function instanceOfNotificationsMethodNotAllowedError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsMethodNotAllowedErrorFromJSON(json: any): NotificationsMethodNotAllowedError {
    return NotificationsMethodNotAllowedErrorFromJSONTyped(json, false);
}

export function NotificationsMethodNotAllowedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsMethodNotAllowedError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsMethodNotAllowedErrorToJSON(value?: NotificationsMethodNotAllowedError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

